var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1251 25.9417V33.7333C37.1251 35.739 35.6823 37.466 33.6931 37.73C29.8669 38.2378 25.9638 38.5 22.0001 38.5C18.0364 38.5 14.1333 38.2378 10.3071 37.73C8.31793 37.466 6.8751 35.739 6.8751 33.7333V25.9417M37.1251 25.9417C37.5604 25.5634 37.9087 25.0953 38.1461 24.5697C38.3834 24.044 38.5042 23.4732 38.5001 22.8965V15.961C38.5001 13.9792 37.0921 12.2668 35.1323 11.9735C33.0557 11.6626 30.9686 11.426 28.8751 11.264M37.1251 25.9417C36.7694 26.2442 36.3551 26.4825 35.8913 26.6383C31.411 28.1249 26.7205 28.8801 22.0001 28.875C17.1454 28.875 12.4759 28.0885 8.10893 26.6383C7.65658 26.4879 7.2376 26.2513 6.8751 25.9417M6.8751 25.9417C6.43976 25.5634 6.09146 25.0953 5.85412 24.5697C5.61677 24.044 5.496 23.4732 5.5001 22.8965V15.961C5.5001 13.9792 6.9081 12.2668 8.86793 11.9735C10.9445 11.6626 13.0316 11.4259 15.1251 11.264M28.8751 11.264V9.625C28.8751 8.53098 28.4405 7.48177 27.6669 6.70818C26.8933 5.9346 25.8441 5.5 24.7501 5.5H19.2501C18.1561 5.5 17.1069 5.9346 16.3333 6.70818C15.5597 7.48177 15.1251 8.53098 15.1251 9.625V11.264M28.8751 11.264C24.2986 10.9103 19.7016 10.9103 15.1251 11.264M22.0001 23.375H22.0148V23.3897H22.0001V23.375Z",
    stroke: "#FEDA14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.0347d9602d07ea5c693da9792dd3d00b.svg";
export { ForwardRef as ReactComponent };